export default "__VITE_ASSET__BVJR88qj__"